import {
  formatGenerationStatus,
  isGenerationStatusActive,
} from "../lib/generation-status-labels.js";

type StatusHintProps = {
  status: string;
};

export function StatusHint({ status }: StatusHintProps) {
  const label = formatGenerationStatus(status);
  if (!label) return null;

  const active = isGenerationStatusActive(status);

  return (
    <span
      className={`status-hint${active ? " status-hint--active" : ""}`}
      aria-live="polite"
    >
      {active ? <span className="status-hint-dot" aria-hidden /> : null}
      <span className="status-hint-label">{label}</span>
    </span>
  );
}
